<template lang="pug">
.form-coordinates
    SvInput(
        disabled
        placeholder="Кликните для получения координат"
        :value="coordinates"
        :withIcon="false"
    )

    .form-coordinates__buttons
        SvButton.form-coordinates__button(
            view="bordered"
            text="Отмена"
            @click="cancel"
        )

        SvButton.form-coordinates__button(
            view="main-small"
            text="Подтвердить"
            @click="confirm"
        )
</template>

<script>
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';

export default {
  name: 'FormCoordinates',

  props: {
    coordinates: {
      type: String,
      default: '',
    },
  },

  methods: {
    confirm() {
      this.$emit('confirm');
    },

    cancel() {
      this.$emit('cancel');
    },
  },

  components: {
    SvInput,
    SvButton,
  },
};
</script>

<style lang="scss" scoped>
.form-coordinates {
    background-color: #fff;
    padding: 30px 40px;

    &__button {
        width: 170px;
    }

    &__buttons {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
    }
}
</style>
